import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Tooltip,
  OverlayTrigger,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { fetchPolls, activePolls } from "PollAction";
import {
  fetchLiveQA,
  fetchSchedules,
  fetchUnpublishedLiveQA,
  published,
  selectedSessionID,
  updatedEventPublished,
  broadcastQA,
} from "LiveQAAction";
import { broadcastPolls } from "PollAction";

import { fetchEventDetails } from "DashboardUserAction";
import { converDateIntoLocalDate, DOMAIN_NAME, classNames } from "Constants";

import LocaleStrings from "Languages";
import Button from "react-bootstrap-button-loader";
export var HEADING_POLL = "poll";
export var HEADING_LIVEQA = "liveqa";
class PollIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
      copied1: false,
    };
    this.lveInfoPop = React.createRef();
    this.lvepollInfoPop = React.createRef();
  }

  componentDidMount() {
    this.props.fetchEventDetails(this.props.session);
    this.getSchedules();
    // if (this.props.heading === HEADING_POLL) {
    // this.getPolls();
    // }
  }

  componentWillUnmount() {
    this.state = {
      copied: false,
      copied1: false,
    };
  }

  // First time Published QA list & Poll list
  getSchedules = () => {
    this.props.fetchSchedules(this.props.session, (response) => {
      if (response.success) {
        let sessions = response.resource.scheduleSession;
        if (sessions.length > 0) {
          this.props.selectedSessionID(sessions[0].sessionid);

          if (this.props.heading === HEADING_POLL) {
            // Fetch poll data
            this.props.fetchPolls(
              this.props.session,
              "active",
              sessions[0].sessionid,
              0,
              (response) => {
                this.props.activePolls("active");
              }
            );
          } else {
            // Fetch QA data
            this.props.fetchLiveQA(
              this.props.session,
              sessions[0].sessionid,
              0,
              (qaResponse) => {
                if (qaResponse.success) {
                  this.props.fetchUnpublishedLiveQA(
                    this.props.session,
                    sessions[0].sessionid,
                    0,
                    (UqaResponse) => {
                      this.props.published("published");
                    }
                  );
                }
              }
            );
          }
        }
      }
    });
  };

  // getPolls = () => {
  //   this.props.fetchPolls(this.props.session, "active", 0, (response) => {
  //     this.props.activePolls("active");
  //   });
  // };

  // Fetch active polls list
  activePolls = () => {
    this.props.fetchPolls(
      this.props.session,
      "active",
      this.props.selectedSession,
      0,
      (response) => {
        this.props.activePolls("active");
        this.props.updatePageNumber(1);
      }
    );
  };

  // Fetch archived polls list
  archivedPolls = () => {
    this.props.fetchPolls(
      this.props.session,
      "archived",
      this.props.selectedSession,
      0,
      (response) => {
        this.props.activePolls("archived");
        this.props.updatePageNumber(1);
      }
    );
  };

  // Fetch Unpublished QA List
  unpublishedQA = () => {
    // this.props.fetchUnpublishedLiveQA(this.props.session, this.props.selectedSession, 0, (UqaResponse) => {
    //     if(UqaResponse.success) {
    //         this.props.fetchLiveQA(this.props.session, this.props.selectedSession, 0, (qaResponse) => {
    this.props.clearAllSelectionData();
    this.props.published("unpublished");
    this.props.pagination(1);

    //         });
    //     }
    // });
  };

  // Fetch Published QA List
  publishedQA = () => {
    // this.props.fetchLiveQA(this.props.session, this.props.selectedSession, 0, (qaResponse) => {
    //     if(qaResponse.success) {
    //         this.props.fetchUnpublishedLiveQA(this.props.session, this.props.selectedSession, 0, (UqaResponse) => {
    this.props.published("published");
    this.props.clearAllSelectionData();
    this.props.pagination(1);
    //         });
    //     }
    // });
  };

  // Fetch QA List by changing schedule session
  getChangeLiveQA = (e) => {
    let sessionid = e.target.value;
    this.props.selectedSessionID(sessionid);

    if (this.props.heading === HEADING_POLL) {
      let select =
        this.props.selectPollListType && this.props.selectPollListType.select
          ? this.props.selectPollListType.select
          : "active";
      this.props.fetchPolls(
        this.props.session,
        select,
        sessionid,
        0,
        (response) => {
          this.props.activePolls(select);
          this.props.updatePageNumber(1);
        }
      );
    } else {
      // if(this.props.selectPublishedType.ispublished == 'published') {
      this.props.fetchLiveQA(this.props.session, sessionid, 0, (qaResponse) => {
        if (qaResponse.success) {
          this.props.fetchUnpublishedLiveQA(
            this.props.session,
            sessionid,
            0,
            (UqaResponse) => {
              if (UqaResponse.success) {
                this.props.clearAllSelectionData();
              } else {
              }
            }
          );
        }
      });
      // }
      // else {
      //     this.props.fetchUnpublishedLiveQA(this.props.session, this.props.selectedSession, 0, (UqaResponse) => {
      //         if(UqaResponse.success) {
      //             this.props.fetchLiveQA(this.props.session, sessionid, 0, (qaResponse) => {
      //                 if(qaResponse.success) {

      //                     this.props.clearAllSelectionData();
      //                 }
      //                 else {

      //                 }
      //             });
      //         }
      //     });
      // }
    }
  };

  // Change event autopublish QA
  chnagePublishQAStatus = () => {
    let { session, eventDetails } = this.props;
    let status = !eventDetails.isautopublish_qa;
    this.props.updatedEventPublished(session, status, (response) => {
      this.props.fetchEventDetails(session);
    });
  };

  refreshLiveQA = () => {
    this.props.pagination(1);
    this.props.clearAllSelectionData();
    this.props.fetchEventDetails(this.props.session);
    this.props.loadingrefresh();
  };

  /* 
  OLD CODE FOR LIVE QA 

  openBroadcastLiveQAModal = () => {
    this.props.broadcastQA({ showModal: true });
  };
  */

  openBroadcastLivePollsModal = () => {
    // Polls & Live QA -> Polls [Open big modal which will show embaded links for live polls]
    this.props.broadcastPolls({ showModal: true });
  };

  /* Copy url [live polls] */
  copyUrl = (callFor) => {
    if (callFor === "qa") {
      this.setState({ copied: true });

      setTimeout(() => {
        this.setState({ copied: false });
      }, 500);
    } else {
      this.setState({ copied1: true });

      setTimeout(() => {
        this.setState({ copied1: false });
      }, 500);
    }
  };

  /***  Overlay Go LIVE (QA/Poll) [callFor -> qa / poll]***/
  liveDiplaySeoVisitBox = (url, callFor) => {
    let { copied1, copied } = this.state;
    // let className = "event-info-popover";
    let ticketUrl = "iudfgiwug";
    let className =
      callFor === "qa"
        ? "event-info-popover qa-popover"
        : "event-info-popover polls-popover"; // style
    let custRightMargin = callFor === "qa" ? 400 : 500; // style

    let commonCopied = callFor === "qa" ? copied : copied1;

    // let closeFc =
    //   callFor === "qa" ? this.closeLiveQaInfo : this.closeLivePllInfo;

    let style = {
      maxWidth: 522,
      width: 522,
      height: 282,
      marginRight: custRightMargin,
    };

    return (
      <Popover
        title={
          callFor === "qa"
            ? LocaleStrings.liveqa_display_info
            : LocaleStrings.livepoll_display_info
        }
        id="popover-basic-preview-polls"
        className={className}
        style={style}
      >
        <PopoverHeader>
          <h3 className="popover-title">LiveQA Display Info</h3>
        </PopoverHeader>
        <PopoverBody>
          <div className="popover-content">
            <button
              type="button"
              className="i-custom-cross-popover pull-right"
              // onClick={closeFc}
              onClick={this.closeLivePllInfo}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
            {/* POP OVER BODY */}
            <div style={{ marginBottom: 20 }}>
              <div className="ticket-dashboard-ticket-created-page-main-div">
                <h4 className="heading-para">
                  {callFor === "qa"
                    ? LocaleStrings.polls_qa_broadcast_live_qa_display_header
                    : LocaleStrings.polls_qa_broadcast_live_poll_display_header}
                </h4>
                <p className="promote-para">
                  {callFor === "qa"
                    ? LocaleStrings.polls_qa_broadcast_live_qa_display_subheader
                    : LocaleStrings.polls_qa_broadcast_live_poll_display_subheader}
                </p>
                <div className="row">
                  <div className="col-md-10">
                    <div className="copy-ticket-page">
                      <div className="ticket-url">{url}</div>
                      <CopyToClipboard
                        text={url}
                        onCopy={(e) => this.copyUrl(callFor)}
                      >
                        <div className="url-copy">
                          <i
                            className={classNames(
                              commonCopied
                                ? "hidden"
                                : "fa fa-files-o i-custom-m",
                              ""
                            )}
                            aria-hidden="true"
                          ></i>
                          {commonCopied
                            ? LocaleStrings.copied
                            : LocaleStrings.button_copy}
                        </div>
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div
                    className="col-md-2"
                    style={{ paddingLeft: 0, paddingTop: 2 }}
                  >
                    <a
                      href={url}
                      target="blank"
                      className="btn btn-custom-blue btn-v-center"
                      style={{ marginLeft: 10 }}
                    >
                      <span aria-hidden="true">
                        {LocaleStrings.button_visit}
                      </span>
                    </a>
                    {/* <button  className="btn btn-custom-blue" >
                    <a
                      href={url}
                      target="blank"
                     
                    >
                      <span aria-hidden="true">
                        {LocaleStrings.button_visit}
                      </span>
                    </a>
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  /*** LIVE QA POPOVER CLOSE ***/
  closeLiveQaInfo = () => {
    // this.refs.lveInfoPop.hide();
    document.body.click();
  };

  closeLivePllInfo = () => {
    // this.refs.lvepollInfoPop.hide();
    document.body.click();
  };

  render() {
    var {
      heading,
      selectPollListType,
      session,
      eventDetails,
      scheduleSessions,
      selectPublishedType,
      livePublishedQAList,
      liveUnpublishedQAList,
      isqarefresh,
      selectedSession,
    } = this.props;

    let url =
      eventDetails && eventDetails.seocode
        ? `https://${eventDetails.seocode}.${DOMAIN_NAME}/o/#/live-poll/${selectedSession}`
        : `https://${DOMAIN_NAME}/o/#/`;

    let url1 =
      eventDetails && eventDetails.seocode
        ? `https://${eventDetails.seocode}.${DOMAIN_NAME}/o/#/live-qa/${selectedSession}`
        : `https://${DOMAIN_NAME}/o/#/`;

    let liveQAChecked = false;
    if (eventDetails && eventDetails.isautopublish_qa) {
      liveQAChecked = true;
    }

    // schedules all sesssion
    let sessionArray = [];
    if (scheduleSessions && scheduleSessions.scheduleSession) {
      scheduleSessions.scheduleSession.map((object, index) => {
        sessionArray.push(
          <option key={`${object.sessionid}-${index}`} value={object.sessionid}>
            {object.trackname === "##NOTRACK##"
              ? `${object.scheduledate} | ${object.title}`
              : `${object.scheduledate} | ${object.trackname} | ${object.title}`}
          </option>
        );
      });
    }

    let totalpublished = 0;
    let totalunpublished = 0;
    if (livePublishedQAList && livePublishedQAList.count) {
      totalpublished = livePublishedQAList.count;
    }

    if (liveUnpublishedQAList && liveUnpublishedQAList.count) {
      totalunpublished = liveUnpublishedQAList.count;
    }

    let activestyle = "";
    let archivedstyle = "";
    if (selectPollListType && selectPollListType.select == "active") {
      activestyle = "btn btn-custom-table-blue";
      archivedstyle = "btn btn-custom-white-lg";
    } else {
      activestyle = "btn btn-custom-white-lg";
      archivedstyle = "btn btn-custom-table-blue";
    }

    let publishedStyle = "btn btn-custom-table-blue";
    let unpublishedStyle = "btn btn-custom-white-lg";
    if (selectPublishedType && selectPublishedType.ispublished != "published") {
      publishedStyle = "btn btn-custom-white-lg";
      unpublishedStyle = "btn btn-custom-table-blue";
    }

    var iconURL = `../../style/images/poll-icons/${heading}-Selected.png`;
    var headingTitle = "";
    switch (heading) {
      case HEADING_POLL:
        headingTitle = "Polls";
        break;
      case HEADING_LIVEQA:
        headingTitle = "Live QA";
        break;

      default:
    }

    return headingTitle === "Polls" ? (
      <>
        {/* <div className="pr-6">
            <div className="content-heading-icon-poll">
              <img src={iconURL} />
            </div>
          </div> */}

        {/* <div>
            <div className="content-heading-title">{headingTitle}</div>
            <div className="">
              <span style={activestyle} onClick={this.activePolls}>
                Active Polls
              </span>{" "}
              |{" "}
              <span style={archivedstyle} onClick={this.archivedPolls}>
                Archived Polls
              </span>
            </div>
          </div> */}
        <div className="btn-group" role="group" aria-label="First group">
          <button
            type="button"
            className={activestyle}
            onClick={this.activePolls}
          >
            {LocaleStrings.polls_qa_active_polls}
          </button>
          <button
            type="button"
            className={archivedstyle}
            onClick={this.archivedPolls}
          >
            {LocaleStrings.polls_qa_archived_polls}
          </button>
        </div>

        <select
          className="form-control dropdown-height-border"
          style={{ maxWidth: 240 }}
          onChange={this.getChangeLiveQA}
        >
          {sessionArray.length > 0 ? (
            sessionArray
          ) : (
            <option key="NO" value="">
              {LocaleStrings.polls_qa_no_session_added}
            </option>
          )}
        </select>

        {/* GO LIVE polls [START] */}
        {this.props.selectedSession ? (
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            rootClose
            // ref="lvepollInfoPop"
            overlay={this.liveDiplaySeoVisitBox(url, "poll")}
          >
            <Button type="button" className="btn-custom-blue">
              {LocaleStrings.polls_qa_broadcast_live_display}
            </Button>
          </OverlayTrigger>
        ) : (
          <button
            className="btn btn-custom-blue"
            onClick={(e) => {
              this.props.showError(
                LocaleStrings.no_session_available_live_display
              );
            }}
          >
            {" "}
            {LocaleStrings.polls_qa_broadcast_live_display}
          </button>
        )}

        {/* 
          -- OLD CODE --
          <button
            className="btn btn-custom-blue"
            onClick={this.openBroadcastLivePollsModal}
          >
            {" "}
            {LocaleStrings.polls_qa_broadcast_live_polls}{" "}
          </button> */}
      </>
    ) : (
      <>
        <div className="btn-group" role="group" aria-label="First group">
          <button
            type="button"
            className={publishedStyle}
            onClick={this.publishedQA}
          >
            {LocaleStrings.published} ( {totalpublished} )
          </button>
          <button
            type="button"
            className={unpublishedStyle}
            onClick={this.unpublishedQA}
          >
            {LocaleStrings.unpublished} ( {totalunpublished} )
          </button>
        </div>

        <select
          className="form-control dropdown-height-border"
          style={{ maxWidth: 240 }}
          onChange={this.getChangeLiveQA}
        >
          {sessionArray.length > 0 ? (
            sessionArray
          ) : (
            <option key="NO" value="">
              {LocaleStrings.polls_qa_no_session_added}
            </option>
          )}
        </select>

        <OverlayTrigger
          key="refresh"
          placement="top"
          overlay={
            <Tooltip id="tooltip-manage">
              {LocaleStrings.polls_qa_refresh_qa_question}
            </Tooltip>
          }
        >
          <button className="btn i-custom-refresh" onClick={this.refreshLiveQA}>
            {" "}
            {isqarefresh ? (
              <i className="fa fa-refresh fa-spin" aria-hidden="true"></i>
            ) : (
              <i className="fa fa-refresh" aria-hidden="true"></i>
            )}{" "}
          </button>
        </OverlayTrigger>

        {/* GO LIVE QA [START] */}
        {/* 
          -- OLD CODE --
          <button
            className="btn btn-custom-blue"
            onClick={this.openBroadcastLiveQAModal}
          >
            {" "}
            {LocaleStrings.polls_qa_broadcast_qa_question}
          </button> 
          */}
        {/* GO LIVE [ENDS] */}
        {this.props.selectedSession ? (
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            rootClose
            // ref="lveInfoPop"
            overlay={this.liveDiplaySeoVisitBox(url1, "qa")}
          >
            <Button type="button" className="btn-custom-blue">
              {LocaleStrings.polls_qa_broadcast_live_display}
            </Button>
          </OverlayTrigger>
        ) : (
          <button
            className="btn btn-custom-blue"
            onClick={(e) => {
              this.props.showError(
                LocaleStrings.no_session_available_live_display
              );
            }}
          >
            {LocaleStrings.polls_qa_broadcast_live_display}
          </button>
        )}

        <div className="pl-6 d-flex">
          {/* <OverlayTrigger
            key="refresh"
            placement="top"
            overlay={<Tooltip id="tooltip-manage">AutoPublish Q&A</Tooltip>}
          >
            <label className="liveqa-switch">
              <input
                type="checkbox"
                onChange={this.chnagePublishQAStatus}
                checked={liveQAChecked}
              />
              <span className="poll-slider poll-round"></span>
            </label>
          </OverlayTrigger> */}
          <label className="liveqa-switch">
            <input
              type="checkbox"
              onChange={this.chnagePublishQAStatus}
              checked={liveQAChecked}
            />
            <span className="poll-slider poll-round"></span>
          </label>
          <span style={{ paddingTop: 12, marginLeft: 10 }}>
            {LocaleStrings.polls_qa_autopublish_qa}
          </span>
        </div>
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    scheduleSessions: state.scheduleSessions.resource,
    selectedSession: state.selectedSession.resource,
    selectPollListType: state.selectPollListType,
    selectPublishedType: state.selectPublishedType,
    livePublishedQAList: state.livePublishedQAList,
    liveUnpublishedQAList: state.liveUnpublishedQAList,
    eventDetails: state.userEventDetails,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchPolls,
  activePolls,
  fetchSchedules,
  fetchLiveQA,
  fetchUnpublishedLiveQA,
  published,
  selectedSessionID,
  updatedEventPublished,
  fetchEventDetails,
  broadcastQA,
  broadcastPolls,
})(PollIcon);
